import React from 'react';

const grievances = () => {
  return (
    <div>
      grievances
    </div>
  );
}

export default grievances;
